webpackJsonp([1],{

/***/ "0xwO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Mh4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "32V3":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAACQCAYAAADnRuK4AAAABmJLR0QA3QCuAJJFwYKVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QseFiM6ttQCKwAABQRJREFUeNrtnUFLVUEUgK+jYiBPKApBEey1aOvKna6D/oHSpqA2QhC0bdlGCNoGtSjeopZBf8B2rfoDvgQpECPhSVCYz1ZRhIq+N+fMOWe+b11v7pz73XPm3hlnRjZXWkcNwIAkQgAIBAgECAQIBIBAgECAQIBAAAgECAQIBAgEgECAQGCJMY1G2p0ekVakuzoVKwNpdqh2+j/3Y5YwJNJh6/Zs3DEQEsWLb6qhk8gT7C0MieLEM9XYaeQJIBASDc/Bl4/FryHV/gR55ah/2Gw/XEYgK0+SNz7dumjiOkwIZOFJYtzjWCBKmd84JYKDPGEEQiJ/cUkEC3nCCdQ0TbN15xLmOMCsQP0fv7g7wtknxzqtZOEiKGU+5cmWgZCoTnmyljAkqk+e7GMgJKpLHpFBNBLZROq+JE8X2zSxJ16lHpC59Q1/r/Hj01dEfjfqxKtkdh2fWfAn0NyTTUpZ0HGPikCMh+LLIy4QEsWWR0UgJIorj5pASKTH/LOuanuqk6mzj94gkfC1psnLcQWauH7D7Y2hdBkQSKOTliWKJk8RgWqVKKI8xQTS6LSlKY+o8hQVSLrzVqY8JOW5+mqveP+KL2mN/Hov+rZ1YawZSaMIJP0klZJIuoTOP/9mIsOaEGgkjYouOSghkWQJtbRpqZm/ypBccqAtUeRBs1mBNIKz/eAa8kQWSDpIBzu7omOT2uQxKZDX13tJeSTHhyEF8vZ6L10apceHIQXyJNHBzm51pcuFQB4kqnHc40ogyxLVLo8bgaQHkoOIgDzOBJIeSO4+vYk8kQWSDu7+h/dn+neSG195PFfN3YmFpcdDbHzlXCDpOa3Tfr9k2wjkKMDHtVOybQRyGNh/2yvZNgI5Dmh3dapY2xorB6oQqNa/OpWcHql6EF0THh6eRACRKKRAyPOXo/4hAsHgWDlczo1AZB8/MeG4JySKI1D/+1cscYYpgbbutrkjzrJQ6DNT251esSUSrcUlsbY5dPc/9l6vif5+CYmu3H9XrO36BHr7UlwazRup0baVLFRcIKnSVSoTndRGa3EppEQpmjwly9lpv/2npFHCjHMWQSQkKtVu6SxUTCDN0nUc8y8+l2lXYCPwkhKlKPKcu+MTrSIlUWoj8FIfYdUFklppN0h5GLakDJpNJEpZqY+w6gJJrLQb5oYM+n/bnd5Q2STKeEhVIIkO5tigs93pNdP3Hpt4k/MmkZpAUqUr11a3k8trTbvTO/WoztxTIxG+Uo/VWrpOQvKozpP6kDtrdFenYh04J5FWtc/F8oZWKUteO6J9LpZ0FvJKIuBx+6SRhUQFKv212Rs5v45rSZQ8yROdXF/HKWEVZh+vpUxEIErXcEicXiT2MuPilV1gbGAZqXPAJO5NVoGk1jZ7HBvUknHzCqSwthmJbGWhZPXCapdHkpz3KotA59ljGWI9RFkEOusey2SfeKVsZHOldcRTV1fZMf0aD3U9VIlAIVEYgZDHX4zsHPt9ylJSCP4WlgPtpaRkoUACUbr8xqy4QLVNlFLCcl9AhROlkbJQqj0ASORUIOShhAFZqIxAZJ84MU3IEweJtdSUsIqQWkttRiCyT7wYJ+RBIvMCMVGqj1bMVQRiolQfrZiLC0Tpil3KRAViEygDmWh9w69AkTaBcjsWmlnwKRClq45SZvLPesAPfIkGBAIEAgQCBAJAIEAgQCBAIAAEAgQCBAIEAkAgQCAwxW+zLhQ0rNccVwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "4E8B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6DCt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kurka256.15996d3.png";

/***/ }),

/***/ "8In8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BwRm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K8+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MsZi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./src/data.js
/* harmony default export */ var src_data = ({
  games: [{
    'id': 0,
    'img': '../static/img/shots/p23.jpg',
    'gif': '../static/img/shots/prophour23.gif',
    'game': 'Prophour23',
    'description': 'A fast paced real-time strategy with unique theme.',
    'urls': ['http://store.steampowered.com/app/317610/Prophour23/', 'https://thotep.itch.io/prophour23', 'https://play.google.com/store/apps/details?id=com.thesecretpie.prophour23.android'],
    'width': 1920,
    'height': 1080,
    'year': 2014,
    'authors': ['thotep'],
    'platforms': ['steam', 'itch', 'android']
  }, {
    'id': 1,
    'img': '../static/img/shots/borstal.jpg',
    'gif': '../static/img/shots/borstal.gif',
    'game': 'Borstal',
    'description': 'Survival roguelike novellas.',
    'urls': ['http://store.steampowered.com/app/453730/Borstal/', 'https://thotep.itch.io/borstal', 'https://play.google.com/store/apps/details?id=com.thesecretpie.borstalfull'],
    'width': 1271,
    'height': 717,
    'year': 2016,
    'authors': ['thotep'],
    'platforms': ['steam', 'itch', 'android']
  }, {
    'id': 2,
    'img': '../static/img/shots/hpl.jpg',
    'gif': '../static/img/shots/hpl.gif',
    'game': 'Howard Phillips Lovecar',
    'description': 'It\'s like GTA1 + Devil Daggers. Stop The Great Old Ones - or die trying!',
    'urls': ['http://store.steampowered.com/app/644370/Howard_Phillips_Lovecar/'],
    'width': 1920,
    'height': 1016,
    'year': 2017,
    'authors': ['thotep'],
    'platforms': ['steam']
  }, {
    'id': 3,
    'img': '../static/img/shots/grandpastable.jpg',
    'gif': '../static/img/shots/grandpastable.gif',
    'game': 'Grandpa\'s Table',
    'description': 'Relaxing logic game with beautiful 3d graphics and more than one hundred and fifty levels!',
    'urls': ['http://store.steampowered.com/app/471570/Grandpas_Table/', 'https://kivano.itch.io/grandpas-table', 'https://play.google.com/store/apps/details?id=net.kivano.grandpatable.androidhd'],
    'width': 1920,
    'height': 1080,
    'year': 2013,
    'company': 'Kivano',
    'authors': ['rejke', 'kubecz3k'],
    'platforms': ['steam', 'itch', 'android', 'ios']
  },
  /* {
    'id': 5,
    'img': '../static/img/shots/hpl.gif',
    'game': 'Howard Phillips Lovecar',
    'description': 'It\'s like GTA1 + Devil Daggers. Stop The Great Old Ones - or die trying!',
    'urls': ['http://store.steampowered.com/app/644370/Howard_Phillips_Lovecar/'],
    'width': 512,
    'height': 512,
    'year': 2017,
    'authors': ['thotep'],
    'platforms': ['steam']
  },
  {
    'id': 6,
    'img': '../static/img/shots/yiqi.jpg',
    'game': 'Yi Qi',
    'description': 'A 2d platfomer about family life in the Late Jurassic period.',
    'urls': ['https://kurki-collective.itch.io/yi-qi'],
    'width': 1920,
    'height': 1080,
    'year': 2017,
    'authors': ['Miro_TREX', 'Mortalo_TREX'],
    'company': 'T-Rex Interactive',
    'platforms': ['itch']
  },
  {
    'id': 7,
    'img': '../static/img/shots/cooking_ninjas.jpg',
    'game': 'Cooking Ninjas',
    'description': 'Hotline Miami vs Overcooked! Steal ingredients and don\'t get caught.',
    'urls': ['https://kurki-collective.itch.io/cooking-ninjas'],
    'width': 919,
    'height': 637,
    'year': 2017,
    'authors': ['aadekk_'],
    'platforms': ['itch']
  }, */
  {
    'id': 8,
    'img': '../static/img/shots/marblemachine.jpg',
    'gif': '../static/img/shots/marblemachine.gif',
    'game': 'Marble Machine',
    'description': 'Experiment and solve over a hundred physic based puzzles!',
    'urls': ['https://play.google.com/store/apps/details?id=net.kivano.marblemachine'],
    'width': 1280,
    'height': 720,
    'year': 2016,
    'company': 'Kivano',
    'authors': ['rejke', 'kubecz3k'],
    'platforms': ['android']
  },
  /* {
    'id': 9,
    'img': '../static/img/shots/skullstone.jpg',
    'gif': '../static/img/shots/skullstone.gif',
    'game': 'Skullstone',
    'description': 'An old-styled dungeon crawler game with modern 3D graphics.',
    'urls': ['http://skullstonegame.com/', 'https://steamcommunity.com/sharedfiles/filedetails/?id=870575498'],
    'width': 1600,
    'height': 900,
    'year': 2018,
    'authors': ['skullstonegame'],
    'platforms': ['page', 'steam']
  }, */
  {
    'id': 10,
    'img': '../static/img/shots/fit2shapes.jpg',
    'gif': '../static/img/shots/fit2shapes.gif',
    'game': 'Fit2Shapes',
    'description': 'Innovative puzzle-arcade game, where you need to match figure for pattern by tapping screen in the right time.',
    'urls': ['https://play.google.com/store/apps/details?id=com.StudioGier.Fit2Shapes'],
    'width': 506,
    'height': 900,
    'year': 2017,
    'authors': ['aadekk_'],
    'company': ['Studio Gier'],
    'platforms': ['android']
  }, {
    'id': 11,
    'img': '../static/img/shots/popClop.jpg',
    'gif': '../static/img/shots/popClop.gif',
    'game': 'Pop Clop',
    'description': 'Easy to learn, but hard to master arcade game, where you need to throw objects like darts, calipers, screwdriver etc. directly into flying balloons.',
    'urls': ['https://play.google.com/store/apps/details?id=com.StudioGier.PopClop'],
    'width': 506,
    'height': 900,
    'year': 2016,
    'authors': ['aadekk_'],
    'company': ['Studio Gier'],
    'platforms': ['android']
  }, {
    'id': 13,
    'img': '../static/img/shots/boxkid.jpg',
    'gif': '../static/img/shots/boxkid.gif',
    'game': 'Box Kid Adventures',
    'description': '2D top down game, full of nasty enemies and brain challenging puzzles.',
    'urls': ['https://steamcommunity.com/sharedfiles/filedetails/?id=509854181', 'http://boxkidadventures.com/'],
    'width': 1920,
    'height': 1080,
    'year': 2018,
    'authors': ['Miro_TREX', 'Mortalo_TREX'],
    'company': 'T-Rex Interactive',
    'platforms': ['steam', 'page']
  }, {
    'id': 14,
    'img': '../static/img/shots/ERscreen.jpg',
    'gif': '../static/img/shots/ERLogoAnim.gif',
    'game': 'Electro Ride',
    'description': "Electro Ride is a Neon-lighted Arcade Racing game with colorful boost zones, color switching and '80 legendary cars.",
    'urls': ['https://steamcommunity.com/sharedfiles/filedetails/?id=909312737'],
    'width': 1226,
    'height': 690,
    'year': 2019,
    'authors': ['SylwesterOsik'],
    'platforms': ['steam']
  }, {
    'id': 15,
    'img': '../static/img/shots/zniwadventure.jpg',
    'gif': '../static/img/shots/zniwadventure.gif',
    'game': 'Zniw Adventure',
    'description': "A prehistoric point 'n click adventure for the entire family.",
    'urls': ['https://store.steampowered.com/app/904750/Zniw_Adventure/', 'https://discordapp.com/invite/9ydTfhq', 'https://www.facebook.com/zniwadventure'],
    'width': 1280,
    'height': 960,
    'authors': ['kurasiupl', 'twarda8'],
    'platforms': ['steam', 'discord', 'page']
  }, {
    'img': '../static/img/shots/TailQuest.jpg',
    'gif': '../static/img/shots/TailQuest.mp4',
    'game': 'TailQuest',
    'description': 'TailQuest is an unique mix of tower defense and 3D puzzle platformer. Join Nell as he tries to defend a vivid world from an invasion of colorful robots. ',
    'urls': ['https://store.steampowered.com/app/824090/TailQuest_Defense/', 'https://www.kivano.games', 'https://discord.gg/dYJVNQb'],
    'width': 1680,
    'height': 1018,
    'year': 2020,
    'company': 'Kivano',
    'authors': ['rejke', 'kubecz3k'],
    'platforms': ['steam', 'page', 'discord']
  }, {
    'img': '../static/img/shots/delta-v.jpg',
    'gif': '../static/img/shots/delta-v.mp4',
    'game': 'ΔV: Rings of Saturn',
    'description': 'Realistic top-down space simulator',
    'urls': ['https://store.steampowered.com/app/846030/V_Rings_of_Saturn/?utm_source=kurki&utm_campagin=kurki.games', 'https://koder.itch.io/dv-rings-of-saturn', 'https://discord.gg/dv'],
    'width': 1920,
    'height': 1080,
    'year': 2020,
    'authors': ['KoderaSoftware'],
    'platforms': ['steam', 'itch', 'discord']
  }, {
    'img': '../static/img/shots/mars.jpg',
    'gif': '../static/img/shots/mars.gif',
    'game': 'Mars Power Industries Deluxe',
    'description': 'A fast paced real-time strategy with unique theme.',
    'urls': ['https://store.steampowered.com/app/977230/Mars_Power_Industries_Deluxe/', 'https://itunes.apple.com/app/mars-power-industries/id1380742537', 'https://play.google.com/store/apps/details?id=com.sevenagames.marspuzzle', 'https://www.microsoft.com/p/mars-power-industries-deluxe/9nkt9q7vzj69', 'https://www.nintendo.com/games/detail/mars-power-industries-switch/'],
    'width': 1920,
    'height': 1080,
    'year': 2018,
    'authors': ['lukz_dev'],
    'platforms': ['steam', 'ios', 'android', 'xbox', 'switch']
  }, {
    'img': '../static/img/shots/livingstone.jpg',
    'gif': '../static/img/shots/livingstone.gif',
    'game': 'Dr Livingstone, I Presume?',
    'description': 'As Henry Stanley, you came to Africa to find the missing Dr Livingstone. Explore a mysterious building full of closed doors and unusual objects and solve puzzles to achieve your goal.',
    'urls': ['https://store.steampowered.com/app/1237510/Dr_Livingstone_I_Presume/'],
    'width': 1920,
    'height': 1080,
    'year': 2021,
    'authors': ['Livi_TheGame'],
    'platforms': ['steam']
  }],
  members: [{
    'name': 'Iza',
    'twitter': 'rejke',
    'img': '../static/img/members/rejke.jpg'
  }, {
    'name': 'Kuba',
    'twitter': 'kubecz3k',
    'img': '../static/img/members/kuba.jpg'
  }, {
    'name': 'Przemek',
    'twitter': 'thotep',
    'img': '../static/img/members/thotep.jpg'
  }, {
    'name': 'Adrian',
    'twitter': 'aadekk_',
    'img': '../static/img/members/adek.jpg'
  }, {
    'name': 'Łukasz',
    'twitter': 'lukz_dev',
    'img': '../static/img/members/lukz_dev.jpg'
  }, {
    'name': 'Marcin',
    'twitter': 'vigrid',
    'img': '../static/img/members/vigrid.jpg'
  }, {
    'name': 'Filip',
    'twitter': 'filiploster',
    'img': '../static/img/members/aare.jpg'
  }, {
    'name': 'Mirek',
    'twitter': 'Miro_TREX',
    'img': '../static/img/members/miro.jpg'
  }, {
    'name': 'Sebastian',
    'twitter': 'Mortalo_TREX',
    'img': '../static/img/members/mortalo.jpg'
  }, {
    'name': 'Sylwester',
    'twitter': 'SylwesterOsik',
    'img': '../static/img/members/SylwesterOsik.jpg'
  }, {
    'name': 'Łukasz',
    'twitter': 'kurasiupl',
    'img': '../static/img/members/crash.jpg'
  }, {
    'name': 'Karolina',
    'twitter': 'twarda8',
    'img': '../static/img/members/twarda.jpg'
  }, {
    'name': 'Mariusz',
    'twitter': 'KoderaSoftware',
    'img': '../static/img/members/koder.jpg'
  }, {
    'name': 'Kamil',
    'twitter': 'Livi_TheGame',
    'img': '../static/img/members/Livi_TheGame.jpg'
  }],
  platforms: {
    'steam': 'Get it on Steam',
    'itch': 'Get it on itch.io',
    'android': 'Get it on Google Play',
    'ios': 'Get it on App Store',
    'page': 'Visit the game\'s page',
    'discord': 'Join the game\'s Discord',
    'xbox': 'Get it on Xbox',
    'switch': 'Get it on Switch'
  }
});
// CONCATENATED MODULE: ./src/EventBus.js


var EventBus = new vue_esm["a" /* default */]({});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GameCard.vue
//
//
//
//
//
//
//
//
//
//
//
//


// import GameInfo from './GameInfo.vue'


/* harmony default export */ var GameCard = ({
  /* components: {
    GameInfo
  }, */
  props: { game: {
      type: Object,
      required: true
    } },
  computed: {
    gameNameDisplay: function gameNameDisplay() {
      if (!this.hovering) {
        return 'display: none;';
      }
      return '';
    },
    main_class: function main_class() {
      return this.game.size + ' card tooltip-target';
    },
    style: function style() {
      var w = this.game.width * (this.hovering ? 0.5 : 1);
      var h = this.game.height * (this.hovering ? 0.5 : 1);
      var maxsize = 150;
      if (this.game.size === 'box2') {
        maxsize = 300;
      } else if (this.game.size === 'box3') {
        maxsize = 450;
      }
      if (h < maxsize) {
        var factor = maxsize / this.game.height;
        h = maxsize;
        w = this.game.width * factor;
      }
      return { backgroundImage: 'url(' + this.game.img + ')', backgroundPosition: this.game.posx + '% ' + this.game.posy + '%', backgroundSize: w + 'px ' + h + 'px', transition: 'all 0.5s' };
    }
  },
  methods: {
    mouseOver: function mouseOver(arg) {
      this.hovering = true;
    },
    mouseOut: function mouseOut() {
      this.hovering = false;
    },
    onClick: function onClick() {
      this.clicked = !this.clicked;
      var rect = this.$el.getBoundingClientRect();
      var width = document.documentElement.clientWidth;
      EventBus.$emit('game-clicked', { game: this.game, left: rect.right > width / 2 });
    }
  },
  mounted: function mounted() {
    var _this = this;

    EventBus.$on('game-unclicked', function (dat) {
      if (dat.game === _this.game) {
        _this.onClick();
      }
    });
  },
  data: function data() {
    return {
      clicked: false,
      hovering: false,
      platforms: src_data.platforms
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ad95ee0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameCard.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.main_class,attrs:{"id":("game_" + (this.game.id))}},[_c('div',{staticClass:"card_image",style:(_vm.style),on:{"mouseover":function($event){_vm.mouseOver()},"mouseout":function($event){_vm.mouseOut()},"click":function($event){_vm.onClick()}}}),_vm._v(" "),_c('div',{staticClass:"game_name",style:(_vm.gameNameDisplay),on:{"mouseover":function($event){_vm.mouseOver()},"mouseout":function($event){_vm.mouseOut()},"click":function($event){_vm.onClick()}}},[_c('span',[_vm._v(_vm._s(_vm.game.game))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_GameCard = (esExports);
// CONCATENATED MODULE: ./src/components/GameCard.vue
function injectStyle (ssrContext) {
  __webpack_require__("BwRm")
  __webpack_require__("8In8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  GameCard,
  components_GameCard,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_GameCard = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Member.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Member = ({
  props: { member: {
      type: Object,
      required: true
    },
    small: {
      type: Boolean,
      required: true
    },
    swaying: {
      type: Boolean,
      required: true
    } },
  computed: {
    style: function style() {
      var offset = Math.ceil(Math.random() * 20) - 10;
      var animtime = 2.5 + Math.random();
      var res = { left: offset + 'px' };
      if (this.swaying) {
        res['animation'] = 'swaying ' + animtime + 's ease-in-out forwards infinite';
      }
      return res;
    },
    avatar: function avatar() {
      if (this.member.img) {
        return this.member.img;
      }
      return 'https://avatars.io/twitter/' + this.member.twitter + '/medium';
    },
    mainClass: function mainClass() {
      return 'avatar_container' + (this.small ? ' small' : '') + (this.swaying ? ' swaying' : '');
    }
  },
  methods: {
    onClick: function onClick() {
      window.open('http://twitter.com/' + this.member.twitter);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a3a8ab7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Member.vue
var Member_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.mainClass,on:{"click":_vm.onClick}},[_c('div',{staticClass:"avatar",style:(_vm.style)},[_c('img',{attrs:{"src":_vm.avatar}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.member.name))])])])}
var Member_staticRenderFns = []
var Member_esExports = { render: Member_render, staticRenderFns: Member_staticRenderFns }
/* harmony default export */ var components_Member = (Member_esExports);
// CONCATENATED MODULE: ./src/components/Member.vue
function Member_injectStyle (ssrContext) {
  __webpack_require__("0xwO")
}
var Member_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Member___vue_template_functional__ = false
/* styles */
var Member___vue_styles__ = Member_injectStyle
/* scopeId */
var Member___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Member___vue_module_identifier__ = null
var Member_Component = Member_normalizeComponent(
  Member,
  components_Member,
  Member___vue_template_functional__,
  Member___vue_styles__,
  Member___vue_scopeId__,
  Member___vue_module_identifier__
)

/* harmony default export */ var src_components_Member = (Member_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GameGif.vue
//
//
//
//
//
//
//
//


// import data from '../data'

/* harmony default export */ var GameGif = ({
  mounted: function mounted() {
    var _this = this;

    EventBus.$on('game-clicked', function (dat) {
      _this.visible = true;
      _this.currentGame = dat['game'];
    });
    EventBus.$on('game-unclicked', function (dat) {
      _this.visible = false;
      _this.currentGame = {};
    });
  },

  computed: {
    mainClass: function mainClass() {
      return 'game_gif' + (this.visible ? ' visible' : '');
    },
    imageSrc: function imageSrc() {
      if (this.currentGame != null) {
        if (this.currentGame.gif) {
          return this.currentGame.gif;
        }
        return this.currentGame.img;
      }
      return '';
    },
    isMP4: function isMP4() {
      if (this.currentGame != null) {
        if (this.currentGame.gif) {
          return this.currentGame.gif.toLowerCase().endsWith('mp4');
        }
      }
      return false;
    }
  },
  methods: {
    onClick: function onClick() {
      // EventBus.$emit('game-unclicked', { game: this.game, left: rect.right > width / 2 })
      EventBus.$emit('game-unclicked', { game: this.currentGame });
    }
  },
  data: function data() {
    return {
      visible: false,
      currentGame: {}
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd87a694","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameGif.vue
var GameGif_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMP4)?_c('video',{class:_vm.mainClass,attrs:{"width":"500","height":"280","autoplay":"","loop":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.imageSrc,"type":"video/mp4"}}),_vm._v("\r\n  Your browser does not support the video tag.\r\n")]):_c('img',{class:_vm.mainClass,attrs:{"src":_vm.imageSrc}})}
var GameGif_staticRenderFns = []
var GameGif_esExports = { render: GameGif_render, staticRenderFns: GameGif_staticRenderFns }
/* harmony default export */ var components_GameGif = (GameGif_esExports);
// CONCATENATED MODULE: ./src/components/GameGif.vue
function GameGif_injectStyle (ssrContext) {
  __webpack_require__("4E8B")
}
var GameGif_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GameGif___vue_template_functional__ = false
/* styles */
var GameGif___vue_styles__ = GameGif_injectStyle
/* scopeId */
var GameGif___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GameGif___vue_module_identifier__ = null
var GameGif_Component = GameGif_normalizeComponent(
  GameGif,
  components_GameGif,
  GameGif___vue_template_functional__,
  GameGif___vue_styles__,
  GameGif___vue_scopeId__,
  GameGif___vue_module_identifier__
)

/* harmony default export */ var src_components_GameGif = (GameGif_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GameInfo.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var GameInfo = ({
  components: {
    Member: src_components_Member
  },
  mounted: function mounted() {
    var _this = this;

    EventBus.$on('game-clicked', function (dat) {
      _this.visible = true;
      _this.currentGame = dat['game'];
      // this.$el.scrollIntoView()
      // window.scroll(0, this.findPos(this.$el) - 50)
      _this.left = dat.left;
      _this.left = false;
      _this.members = [];
      for (var i = 0; i < src_data.members.length; i++) {
        if (_this.currentGame.authors.indexOf(src_data.members[i].twitter) >= 0) {
          _this.members.push(assign_default()({}, src_data.members[i]));
        }
      }
    });
    EventBus.$on('game-unclicked', function (dat) {
      _this.visible = false;
      _this.currentGame = {};
    });
  },

  computed: {
    main_class: function main_class() {
      var vis = this.visible;
      return 'game_info' + (vis ? ' visible' : '') + (this.left ? ' left' : ' right');
    }
  },
  data: function data() {
    return {
      hovering: false,
      members: [],
      platforms: src_data.platforms,
      left: true,
      visible: false,
      currentGame: {}
    };
  },

  methods: {
    findPos: function findPos(obj) {
      var curtop = 0;
      if (obj.offsetParent) {
        while (obj != null) {
          curtop += obj.offsetTop;
          obj = obj.offsetParent;
        }
        return [curtop];
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efe6dbec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameInfo.vue
var GameInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.main_class,on:{"game-clicked":function($event){_vm.gameClicked(_vm.arg)}}},[_c('div',{staticStyle:{"font-size":"18px","margin":"8px"}},[_vm._v(_vm._s(_vm.currentGame.game))]),_vm._v(" "),_c('div',{staticStyle:{"margin":"8px","font-size":"14px"}},[_vm._v(_vm._s(_vm.currentGame.description))]),_vm._v(" "),(this.currentGame.company)?_c('div',[_vm._v(_vm._s(("Made by " + (_vm.currentGame.company) + ". Members:")))]):_c('div',[_vm._v(_vm._s("Made by:"))]),_vm._v(" "),_c('div',{staticClass:"arrow"}),_vm._v(" "),_c('div',{staticClass:"members_horizontal"},_vm._l((this.members),function(member){return _c('Member',{key:member.twitter,attrs:{"member":member,"small":true,"swaying":false}})})),_vm._v(" "),_vm._l((this.currentGame.platforms),function(item,index){return _c('div',{staticClass:"platforms"},[_c('img',{attrs:{"src":("../static/img/" + item + ".png")}}),_vm._v(" "),_c('a',{attrs:{"href":_vm.currentGame.urls[index],"target":"_blank"}},[_vm._v(_vm._s(_vm.platforms[item]))])])})],2)}
var GameInfo_staticRenderFns = []
var GameInfo_esExports = { render: GameInfo_render, staticRenderFns: GameInfo_staticRenderFns }
/* harmony default export */ var components_GameInfo = (GameInfo_esExports);
// CONCATENATED MODULE: ./src/components/GameInfo.vue
function GameInfo_injectStyle (ssrContext) {
  __webpack_require__("ra8g")
  __webpack_require__("2Mh4")
}
var GameInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GameInfo___vue_template_functional__ = false
/* styles */
var GameInfo___vue_styles__ = GameInfo_injectStyle
/* scopeId */
var GameInfo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GameInfo___vue_module_identifier__ = null
var GameInfo_Component = GameInfo_normalizeComponent(
  GameInfo,
  components_GameInfo,
  GameInfo___vue_template_functional__,
  GameInfo___vue_styles__,
  GameInfo___vue_scopeId__,
  GameInfo___vue_module_identifier__
)

/* harmony default export */ var src_components_GameInfo = (GameInfo_Component.exports);

// EXTERNAL MODULE: ./node_modules/masonry-layout/masonry.js
var masonry = __webpack_require__("FWuv");
var masonry_default = /*#__PURE__*/__webpack_require__.n(masonry);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HomeView.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var HomeView = ({
  components: {
    GameCard: src_components_GameCard,
    Member: src_components_Member,
    GameGif: src_components_GameGif,
    GameInfo: src_components_GameInfo
  },
  methods: {
    displayDetails: function displayDetails(id) {
      this.$router.push({ name: 'detail', params: { id: id } });
    }
  },
  data: function data() {
    function shuffleArray(array) {
      for (var _i = array.length - 1; _i > 0; _i--) {
        var j = Math.floor(Math.random() * (_i + 1));
        var _ref = [array[j], array[_i]];
        array[_i] = _ref[0];
        array[j] = _ref[1];
      }
    }
    var gamesList = [];
    var factor = 1;
    for (var _i2 = 0; _i2 < src_data.games.length * factor; _i2++) {
      var game = assign_default()({}, src_data.games[_i2 % src_data.games.length]);
      var maxsize = 1;
      var rnd = Math.random();
      if (rnd > 0.8) {
        maxsize = 3;
      } else if (rnd > 0.5) {
        maxsize = 2;
      }
      // jednak bez 3
      // maxsize = Math.min(maxsize, 2)
      if (game['size'] === undefined) {
        game['size'] = 'box' + Math.ceil(Math.random() * maxsize);
      }
      game['posx'] = 20 + Math.ceil(Math.random() * 30);
      game['posy'] = 20 + Math.ceil(Math.random() * 30);
      gamesList.push(game);
    }
    shuffleArray([]);
    var members = [];
    for (var i = 0; i < src_data.members.length; i++) {
      members.push(assign_default()({}, src_data.members[i]));
    }
    shuffleArray(members);
    var membersLeft = [];
    var membersRight = [];
    for (i = 0; i < members.length; i++) {
      if (i % 2 === 0) {
        membersLeft.push(members[i]);
      } else {
        membersRight.push(members[i]);
      }
    }
    return {
      'games': gamesList,
      'membersLeft': membersLeft,
      'membersRight': membersRight,
      'members': members
    };
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      var msnry = new masonry_default.a('.main_grid', {
        itemSelector: '.card',
        columnWidth: 166
      });
      msnry.layout();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3609d413","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeView.vue
var HomeView_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main_members_horizontal"},_vm._l((this.members),function(member){return _c('Member',{key:member.twitter,attrs:{"member":member,"small":false,"swaying":true}})})),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"main_grid"},_vm._l((this.games),function(game){return _c('GameCard',{key:game.id,attrs:{"game":game}})})),_vm._v(" "),_c('GameGif'),_vm._v(" "),_c('GameInfo')],1)}
var HomeView_staticRenderFns = []
var HomeView_esExports = { render: HomeView_render, staticRenderFns: HomeView_staticRenderFns }
/* harmony default export */ var components_HomeView = (HomeView_esExports);
// CONCATENATED MODULE: ./src/components/HomeView.vue
function HomeView_injectStyle (ssrContext) {
  __webpack_require__("YM4v")
}
var HomeView_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var HomeView___vue_template_functional__ = false
/* styles */
var HomeView___vue_styles__ = HomeView_injectStyle
/* scopeId */
var HomeView___vue_scopeId__ = "data-v-3609d413"
/* moduleIdentifier (server only) */
var HomeView___vue_module_identifier__ = null
var HomeView_Component = HomeView_normalizeComponent(
  HomeView,
  components_HomeView,
  HomeView___vue_template_functional__,
  HomeView___vue_styles__,
  HomeView___vue_scopeId__,
  HomeView___vue_module_identifier__
)

/* harmony default export */ var src_components_HomeView = (HomeView_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Overlay.vue
//
//
//
//
//



/* harmony default export */ var Overlay = ({
  mounted: function mounted() {
    var _this = this;

    EventBus.$on('game-clicked', function (dat) {
      _this.visible = true;
      _this.currentGame = dat['game'];
    });
  },

  computed: {
    mainClass: function mainClass() {
      return 'overlay' + (this.visible ? ' visible' : '');
    }
  },
  methods: {
    onClick: function onClick() {
      // EventBus.$emit('game-unclicked', { game: this.game, left: rect.right > width / 2 })
      EventBus.$emit('game-unclicked', { game: this.currentGame });
      this.visible = false;
      this.currentGame = null;
    }
  },
  data: function data() {
    return {
      visible: false,
      currentGame: null
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d54e119a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Overlay.vue
var Overlay_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.mainClass,on:{"click":_vm.onClick}})}
var Overlay_staticRenderFns = []
var Overlay_esExports = { render: Overlay_render, staticRenderFns: Overlay_staticRenderFns }
/* harmony default export */ var components_Overlay = (Overlay_esExports);
// CONCATENATED MODULE: ./src/components/Overlay.vue
function Overlay_injectStyle (ssrContext) {
  __webpack_require__("K8+g")
}
var Overlay_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Overlay___vue_template_functional__ = false
/* styles */
var Overlay___vue_styles__ = Overlay_injectStyle
/* scopeId */
var Overlay___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Overlay___vue_module_identifier__ = null
var Overlay_Component = Overlay_normalizeComponent(
  Overlay,
  components_Overlay,
  Overlay___vue_template_functional__,
  Overlay___vue_styles__,
  Overlay___vue_scopeId__,
  Overlay___vue_module_identifier__
)

/* harmony default export */ var src_components_Overlay = (Overlay_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var App = ({
  components: {
    HomeView: src_components_HomeView,
    Overlay: src_components_Overlay
  },
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a655f9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('Overlay'),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('br'),_vm._v(" "),_c('HomeView')],1)}
var App_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logos"},[_c('img',{staticStyle:{"width":"168px","height":"168px","padding-right":"40px"},attrs:{"src":__webpack_require__("6DCt")}}),_vm._v(" "),_c('img',{staticStyle:{"height":"168px"},attrs:{"src":__webpack_require__("NNrY")}}),_vm._v(" "),_c('div',{staticClass:"navigation"},[_c('a',{staticClass:"navigation__link",attrs:{"href":"http://twitter.com/kurkigames"}},[_c('img',{staticStyle:{"width":"32px"},attrs:{"src":__webpack_require__("iiTr")}})]),_vm._v(" "),_c('a',{staticClass:"navigation__link",attrs:{"href":"mailto:kurki.games@gmail.com"}},[_c('img',{staticStyle:{"width":"32px"},attrs:{"src":__webpack_require__("32V3")}})]),_vm._v(" "),_c('a',{staticClass:"navigation__link",attrs:{"href":"https://www.facebook.com/KurkiGames"}},[_c('img',{staticStyle:{"width":"32px"},attrs:{"src":__webpack_require__("Xv6h")}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"layout-title"},[_vm._v("Hi! We are a group of Polish game developers.")])])}]
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("xNnO")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DetailView.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var DetailView = ({
  data: function data() {
    return {
      'pictures': src_data.pictures
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1242bb96","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DetailView.vue
var DetailView_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-grid"},[_c('div',{staticClass:"mdl-cell mdl-cell--8-col"},[_c('div',{staticClass:"picture"},[_c('img',{attrs:{"src":this.pictures[_vm.$route.params.id].url}})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('span',[_vm._v(_vm._s(this.pictures[_vm.$route.params.id].info))])])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--4-col mdl-cell--8-col-tablet"},[_c('div',{staticClass:"comment"},[_c('span',[_vm._v(_vm._s(this.pictures[_vm.$route.params.id].comment))])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('router-link',{staticClass:"mdl-button mdl-js-button mdl-button--raised mdl-button--colored",attrs:{"to":"/post"}},[_vm._v("\n        ANSWER\n      ")])],1)])])}
var DetailView_staticRenderFns = []
var DetailView_esExports = { render: DetailView_render, staticRenderFns: DetailView_staticRenderFns }
/* harmony default export */ var components_DetailView = (DetailView_esExports);
// CONCATENATED MODULE: ./src/components/DetailView.vue
function DetailView_injectStyle (ssrContext) {
  __webpack_require__("MsZi")
}
var DetailView_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var DetailView___vue_template_functional__ = false
/* styles */
var DetailView___vue_styles__ = DetailView_injectStyle
/* scopeId */
var DetailView___vue_scopeId__ = "data-v-1242bb96"
/* moduleIdentifier (server only) */
var DetailView___vue_module_identifier__ = null
var DetailView_Component = DetailView_normalizeComponent(
  DetailView,
  components_DetailView,
  DetailView___vue_template_functional__,
  DetailView___vue_styles__,
  DetailView___vue_scopeId__,
  DetailView___vue_module_identifier__
)

/* harmony default export */ var src_components_DetailView = (DetailView_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/home',
    name: 'home',
    component: src_components_HomeView
  }, {
    path: '/detail/:id',
    name: 'detail',
    component: src_components_DetailView
  }]
}));
// EXTERNAL MODULE: ./node_modules/v-tooltip/dist/v-tooltip.esm.js
var v_tooltip_esm = __webpack_require__("VN6J");

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





vue_esm["a" /* default */].use(v_tooltip_esm["a" /* default */]);

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "NNrY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kurki_collective256.58adebf.png";

/***/ }),

/***/ "Xv6h":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAACQCAYAAADnRuK4AAAABmJLR0QA3QCuAJJFwYKVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QseFiQm7ZTIowAAAahJREFUeNrt3cENgjAUgOFCuOoQjKXzMZYOwQL1RKIkXiqtLf2+mx7xz0OSlzLEGGN487xfA3wzL+vH52ELSDikhDSKhxRbM6NLwS+Gx+0SXQZSmUAICAEhIAQEAkJACAgBgYAQEAJCQCAgBISAEBAF7RfZa2IjsZNAcu29T34+U0VAwhGQcARER+F4ChOPgMQjIPEIiF7jEZB4BISATB8BiccEAgGZPgJCQKaPgEBACIjK2Qeq+P9PC+d3m0CVauXwdwGJR0DiERChzXeWCAgBISCP8AJCQCAgBISAEBAICAEhIAQEAkJACAgBgYAQEAKiZd28bKXXLcLci/omEAJCQAgIAYGAKPUEJiAEhIAQEAICASEgBMT/lTouT0AICAEhIAQEAqKkbpbqj5RrQd9J9biFgYAQEAJCQCAgBISAEBAICAEhIAQEAkJACAgBISAQEAJCQAgIBISAEBACAgEhIASEgEBACAgBISAEBAJCQAgIAYGAEBACQkAgIASEgBAQCAgBISDOEFCu939yfvOymkAccAszhUiZPiGEMO2/aPHV05QPZ/MCvttT13tfL/AAAAAASUVORK5CYII="

/***/ }),

/***/ "YM4v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iiTr":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ra8g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xNnO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ee3b8d24ca670659c4b9.js